
import { defineComponent, PropType } from 'vue'
import { HelpPagesActionType, IHelpPages } from '@/store/modules/help-pages/interfaces'
import AsahiTypography from '@/components/library/Typography.vue'
import AsahiButton from './library/AsahiButton.vue'
import refreshAfterChangeLanguage from '@/mixins/refreshAfterChangeLanguage'

import 'vue3-carousel/dist/carousel.css'
import AsahiClose from './library/assets/AsahiClose.vue'
import WarningGray from './library/icons/WarningGray.vue'
import { generalServiceV1API, magnoliaServiceAPI } from '@/store/api-instance'

export default defineComponent({
  name: 'AlertModal',

  components: {
    AsahiTypography,
    AsahiButton,
    AsahiClose,
    WarningGray
  },

  mixins: [refreshAfterChangeLanguage],

  data () {
    return {
      currentSlide: 0,
      displayTime: ''
    }
  },

  computed: {
    user () {
      return this.$store.state.auth.user
    },

    isLoggedIn () {
      return this.user.isLoggedIn
    }
  },

  props: {
    content: {
      type: Object as PropType<any>,
      default: () => ({})
    },
    closeModal: {
      type: Function,
      default: () => {
        /* */
      }
    }
  },

  methods: {

    confirm () {
      this.setVisualizedAlert(this.content.id, this.$route.name as string, this.content.mandatory === 'true')
      this.addVisualizationCount()
      const currentLocation = this.$route.name as string
      this.$gtm.trackEvent({ ecommerce: null })
      this.$gtm.trackEvent({
        event: 'select_promotion',
        promotion_id: this.content.id,
        promotion_name: this.content.name,
        page_location: window.location.href,
        page_path: currentLocation,
        event_timestamp: new Date().toISOString(),
        display_sequence: this.content.numberOfViews,
        action: 'cta',
        cta_text: this.content?.buttonLabel,
        display_duration_seconds: Math.floor((Date.now() - new Date(this.displayTime).getTime()) / 1000)
      })
      this.closeModal(this.displayTime)
    },

    handleClick (event: any) {
      const link = event.target.closest('a')

      if (!link) return
      const currentLocation = this.$route.name as string

      this.$gtm.trackEvent({ ecommerce: null })
      this.$gtm.trackEvent({
        event: 'select_promotion',
        promotion_id: this.content.id,
        promotion_name: this.content.name,
        page_location: window.location.href,
        page_path: currentLocation,
        event_timestamp: new Date().toISOString(),
        display_sequence: this.content.numberOfViews,
        action: 'hyperlink',
        link_url: link.href,
        link_text: link.innerText,
        display_duration_seconds: Math.floor((Date.now() - new Date(this.displayTime).getTime()) / 1000)
      })
    },
    done () {
      if (this.content.mandatory !== 'true') {
        this.setVisualizedAlert(this.content.id, this.$route.name as string, this.content.mandatory === 'false')
        const currentLocation = this.$route.name as string
        this.$gtm.trackEvent({ ecommerce: null })
        this.$gtm.trackEvent({
          event: 'select_promotion',
          promotion_id: this.content.id,
          promotion_name: this.content.name,
          page_location: window.location.href,
          page_path: currentLocation,
          event_timestamp: new Date().toISOString(),
          display_sequence: this.content.numberOfViews,
          action: 'cta',
          cta_text: this.content?.buttonLabel,
          display_duration_seconds: Math.floor((Date.now() - new Date(this.displayTime).getTime()) / 1000)
        })
        this.closeModal(this.displayTime)
      }
    },

    async addVisualizationCount () {
      if (this.isLoggedIn) {
        const customertype =
      localStorage.getItem('customertype') || ''

        const uid = sessionStorage.getItem('uid')

        await magnoliaServiceAPI.put(
          'alerts/' + this.content.id,
          {},
          {
            params: {
              customertype,
              uid
            }
          }
        )
      }
    },

    setVisualizedAlert (id: string, page: string, confirmationNeeded: boolean) {
      let alertsString = []
      const visualizedAlert = { id, page, confirmationNeeded }
      alertsString = (localStorage.getItem('alerts') && JSON.parse(localStorage.getItem('alerts') || '')) || []
      alertsString.push(visualizedAlert)
      localStorage.setItem('alerts', JSON.stringify(alertsString))
    }
  },

  async mounted () {
    if (this.content?.mandatory !== 'true') { this.addVisualizationCount() }
    this.displayTime = new Date().toISOString()
  }
})
